import React from "react";
import { View, Text, StyleSheet, TouchableOpacity,
	Platform, Dimensions, I18nManager, AsyncStorage } from "react-native";
	
import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"
import mainFirebase from "../config/firebase.json"

import { FontAwesome5 } from "@expo/vector-icons";
import { Ionicons } from "@expo/vector-icons";
import Main from "../widgets/Main";
import GoogleMapComponentWithMarker from "../widgets/Maps";
import Geocode from "react-geocode";
import Autocomplete from 'react-google-autocomplete';
import MainComponent from "../utilities/MainComponent";
import AppContext from "../utilities/AppContext"
import i18n from 'i18n-js';
import locale from "antd/lib/date-picker/locale/en_US";

Geocode.setApiKey(mainFirebase.apiKey);
Geocode.enableDebug();

export default class DeliveryScreen extends MainComponent {	

	static path = "delivery"
	state = {
		store: {},
		value: "",
		search: "",
		title: "Menu",
		showFullMode 	: true,
		data : [],
		location: {coords: store.latlng, address: ""}
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);
		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth
	
		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}

		this.onMapLoad 		 = this.onMapLoad.bind(this);
		this.onPlaceSelected = this.onPlaceSelected.bind(this)
		this.onGeoLoad 		 = this.onGeoLoad.bind(this)
		this.prepareHandler  = this.prepareHandler.bind(this)
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})
		
		if(this.context.location == undefined)
			this.context.location =  {coords: store.latlng, address: ""}
		else
			this.state.location = this.context.location

		this.getDetails()
	}

	getDetails = async () => {		
		await Font.loadAsync(color.appFonts);
		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
				value = JSON.parse(value)			
            this.setState({store: value})
            
        } catch (error) {
            console.log(error)
        }
	}
	
	/**
	 * 
	 * @param {*} place 
	 */
	onPlaceSelected(place){

		let coords = {lat: place.geometry.location.lat(), lng:place.geometry.location.lng()}
		this.setState({location : {coords: coords, address: place.formatted_address}})
	}

	onGeoLoad(){

		let mapRef = this._mapComponent;
		console.log(mapRef)
		if(mapRef === undefined)
			return

		let coords = {lat: mapRef.getCenter().lat(), lng:mapRef.getCenter().lng()}
		Geocode.fromLatLng( mapRef.getCenter().lat() , mapRef.getCenter().lng() ).then(
			response => {
			 	const address = response.results[0].formatted_address
				this.setState({location : {coords: coords, address: address}})
				console.log({location : {coords: coords, address: address}})
			},
			error => {
				 console.error(error);
			}
		);
	}

	onMapLoad(map){
		this._mapComponent = map;
	}

	prepareHandler(props){
		if(this.state.googleMapProps == undefined){
			this.state.googleMapProps = props
			this.setState({googleMapProps: props})
		}
	}

	async moveToOrder(){
		var onUpdate = this.context.onUpdate 
		if(onUpdate != undefined)
			onUpdate({ data: this.state.location });	
		this.props.navigation.navigate('checkout', {index: 1})
	}
	
	// List View 
	renderDetails(marginTop){

		let mapsUrl = "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=" + mainFirebase.apiKey
		return (
			<View style={{flex:1, marginTop: marginTop, backgroundColor: 'white'}}>
					
					
					{ this.state.googleMapProps != undefined &&(
						<Autocomplete   
							googlemap={this.state.googleMapProps.googlemap}
							style={{
								marginLeft: 15, marginRight: 15,
								backgroundColor: "green",
								outline:"none",
								fontSize: 16, fontFamily: "main-regular",
								backgroundColor: '#F5F5F5', 
								height: 40, 
								flex:1,
								border:'none',
								borderRadius: 10,
								paddingRight: 15,
								paddingLeft: 15,
								paddingTop: 10,
								paddingBottom: 10
							}}
							onPlaceSelected={this.onPlaceSelected}
							types={['(regions)']}
							//componentRestrictions={{country: store.countries}}
						/>)}

						<View style={{height: 15}} />
						<Text style={{textAlign: "center", flex:1, fontFamily: 'main-regular', color:color.detailsColor, fontSize:14}}>{i18n.t('deliveryUpText')}</Text>
						<View style={{height: 15}} />

					<GoogleMapComponentWithMarker
							onMapLoad={this.onMapLoad}
							onDragEnd={this.onGeoLoad}
							prepareHandler={this.prepareHandler}
							showSearch={true}
							disableMarker={true}
							draggable={true}
							disableDefaultUI={true}
							latlng={this.state.location.coords}
							googleMapURL={mapsUrl}
							loadingElement={<div style={{ height: `100%` }} />}
							containerElement={<div style={{ height: `100%` }} />}
							mapElement={<div style={{ height: `100%` }} />}
					/>			

					<View pointerEvents="none" style={{zIndex:9999, flex:1, height: '100%', width:'100%', position:"absolute", justifyContent:"center" , alignContent:"center", alignItems:"center"}}  >
						<FontAwesome5
							name="map-marker" size={32} color={this.state.store.primaryColor} />
					</View>				
					
																							
				<View style={{height: 64, backgroundColor:"transparent", justifyContent: "center", marginTop: "auto"}}>											
						<TouchableOpacity style={{marginLeft: 10, marginRight: 10, marginBottom: 8, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.moveToOrder() }}
								>
							<View style={{flexDirection: "row", justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
								<Text style={{ fontFamily: 'main-bold',position: "absolute", marginLeft: "auto", marginRight: "auto", color:'#FFF', fontSize:14}}>{i18n.t('saveLocation')}</Text>
							</View>
						</TouchableOpacity>
				</View>															
			
			</View>															
		)
	}

	render() {

		var that = this
		var icoName = "ios-arrow-back"
		if(I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		return (
			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>

				{this.state.showFullMode && (										
					
					<View style={styles.webContainer}>						
						
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>

	                        {that.renderDetails(50)}

							<View style={styles.topBar}>															
								<View style={{width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
									<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t('addDelivery')}</Text>																						
								</View>	
								<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems: "center"}}
										onPress={() => { this.props.navigation.navigate('checkout', {index: 1}) }} >
										<Ionicons name={icoName} size={24} color={'black'} />
								</TouchableOpacity>		
							</View>

						</View>

						<Main {...this.state} changeMenu={this.changeMenu} />

					</View>					
				)}
				
				{!this.state.showFullMode && !this.state.showMenu && (
					<View style={styles.container}>						
												
						<View style={{backgroundColor: color.backgroundColor, height: this.state.height}}>
	                        {that.renderDetails(50)}
						</View>

						<View style={styles.topBar}>	
							<View style={{flex: 1, width: "100%", position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center"}}>
								<Text style={{color: 'black', fontFamily:"main-bold", textAlign: "center", fontSize: 16}}>{i18n.t('addDelivery')}</Text>																						
							</View>	
							<TouchableOpacity style={{height:40, width: 40, justifyContent: "center", alignItems: "center"}}
									onPress={() => { this.props.navigation.navigate('checkout', {index: 1}) }} >
									<Ionicons name={icoName} size={24} color={'black'} />
							</TouchableOpacity>													
						</View>
						
					</View>
				)}
				
			</View>

			)}
			</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: color.bigSeparator
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});